import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
                抖
              </span>
              <span className="font-heading text-2xl leading-none text-foreground-950">抖漫</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-600">
              抖漫是面向漫画爱好者的优质在线阅读平台，聚合热门漫画、原创作品与权威排行，帮你轻松发现并追更心仪的作品。
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-medium text-foreground-900">热门分类</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              {comicCategories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link to={`/category/${category.id}`} className="transition hover:text-primary-600">
                    {category.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-medium text-foreground-900">发现好漫</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/list?sort=hot" className="transition hover:text-primary-600">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/list?sort=new" className="transition hover:text-primary-600">
                  新作上线
                </Link>
              </li>
              <li>
                <Link to="/list?sort=rank" className="transition hover:text-primary-600">
                  排行榜
                </Link>
              </li>
              <li>
                <Link to="/user/favorites" className="transition hover:text-primary-600">
                  我的收藏
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-medium text-foreground-900">关于我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition hover:text-primary-600">
                  平台介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-600">
                  版权声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-600">
                  反馈与联系
                </Link>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3 text-foreground-500">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50">
                <i className="ri-mail-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50">
                <i className="ri-message-3-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-200/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 抖漫 · 优质漫画阅读平台｜本站漫画资料均为演示内容</p>
          <p className="flex items-center gap-3">
            <span>本站不提供下载与付费服务</span>
            <Link to="/about" className="transition hover:text-primary-600">
              用户协议
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}